import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import React from 'react'
import TextButton from 'components/Luxkit/Button/TextButton'
import { CAREERS_PAGE_ANCHORS } from 'components/Pages/CareersPage/CareersPage'
import { pushWithRegion } from 'actions/NavigationActions'
import { useAppDispatch } from 'hooks/reduxHooks'
import Group from 'components/utils/Group'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

const WorkWithUsPane = styled(Pane)`
  padding: ${rem(48)} 0;
`
const BodyTextNoMarginDesktop = styled(BodyText)`
  margin-top: ${rem(24)};
  ${mediaQueryUp.tablet} {
    margin-top: unset;
  }
`

function WorkWithUs() {
  const dispatch = useAppDispatch()
  return (
    <WorkWithUsPane>
      <LayoutContainer >
        <Group gap={24} direction="vertical" horizontalAlign="start">
          <Heading variant="heading2">
            Want to work with us?
          </Heading>
          <div>
            <BodyText variant="large">
              Are you passionate about travel and dedicated to delivering unparalleled experiences?
            </BodyText>
            <BodyTextNoMarginDesktop variant="large">
              Come and join Luxury Escapes, recognised as one of the 'Best Places to Work 2022' by the Australian Financial Review.
            </BodyTextNoMarginDesktop>
          </div>
          <TextButton kind="primary" size="large" onClick={() => { dispatch(pushWithRegion('/careers#' + CAREERS_PAGE_ANCHORS.OPEN_POSITIONS)) }} >
            View open positions
          </TextButton>
        </Group>
      </LayoutContainer>
    </WorkWithUsPane>
  )
}

export default WorkWithUs
